import { useState, useEffect, useRef } from "react";
import "./styles.css";

const Tooltip = (props: any) => {
  const { api, content: Content, children } = props;

  const areaRef = useRef<any>(null);
  const tooltipNodeRef = useRef<any>(null);

  const [areaCoords, setAreaCoords] = useState<any>({});
  const [tooltipData, setTooltipData] = useState<any>(null);
  const [pos, setPos] = useState<any>({});

  function findAttribute(node: any) {
    while (node) {
      if (node.getAttribute) {
        const id = node.getAttribute("data-tooltip-id");
        const at = node.getAttribute("data-tooltip-at");
        const tooltip = node.getAttribute("data-tooltip");
        if (id || tooltip) return { id, tooltip, target: node, at };
      }
      node = node.parentNode;
    }

    return { id: null, tooltip: null, target: null, at: null };
  }

  useEffect(() => {
    const tooltipNode = tooltipNodeRef.current;
    if (tooltipNode && pos && (pos.text || Content)) {
      const tooltipCoords = tooltipNode.getBoundingClientRect();

      let updated = false;
      let newLeft = pos.left;
      let newTop = pos.top;

      if (tooltipCoords.right >= areaCoords.right) {
        newLeft = areaCoords.width - tooltipCoords.width - 5;
        updated = true;
      }
      if (tooltipCoords.bottom >= areaCoords.bottom) {
        newTop = pos.top - (tooltipCoords.bottom - areaCoords.bottom + 2);
        updated = true;
      }

      if (updated) {
        setPos((prev: any) => {
          if (!prev) return prev;
          return { ...prev, left: newLeft, top: newTop };
        });
      }
    }
  }, [pos, areaCoords, Content]);

  const timerRef = useRef<any>(null);
  const TIMEOUT = 300;
  const debounce = (code: any) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      code();
    }, TIMEOUT);
  };

  function move(e: any) {
    let { id, tooltip, target, at } = findAttribute(e.target);
    setPos(null);
    setTooltipData(null);

    if (!tooltip) {
      if (!id) {
        clearTimeout(timerRef.current);
        return;
      } else {
        tooltip = getTaskText(id);
      }
    }

    const clientX = e.clientX;

    debounce(() => {
      if (id) {
        setTooltipData(getTaskObj(prepareId(id)));
      }

      const targetCoords = target.getBoundingClientRect();
      const areaEl = areaRef.current;
      const areaRect = areaEl
        ? (areaEl as any).getBoundingClientRect()
        : { top: 0, left: 0, right: 0, bottom: 0, width: 0, height: 0 };

      let top, left;
      if (at === "left") {
        top = targetCoords.top + 5 - areaRect.top;
        left = targetCoords.right + 5 - areaRect.left;
      } else {
        top = targetCoords.top + targetCoords.height - areaRect.top;
        left = clientX - areaRect.left;
      }

      setAreaCoords(areaRect);
      setPos({ top, left, text: tooltip });
    });
  }

  function getTaskObj(id: any) {
    return api?.getTask(prepareId(id)) || null;
  }

  function getTaskText(id: any) {
    return getTaskObj(id)?.text || "";
  }

  function prepareId(id: any) {
    const numId = parseInt(id);
    return isNaN(numId) ? id : numId;
  }

  return (
    <div
      className="wx-KG0Lwsqo wx-tooltip-area"
      ref={areaRef}
      onMouseMove={move}
    >
      {pos && (pos.text || Content) ? (
        <div
          className="wx-KG0Lwsqo wx-gantt-tooltip"
          ref={tooltipNodeRef}
          style={{ top: `${pos.top}px`, left: `${pos.left}px` }}
        >
          {Content ? (
            <Content data={tooltipData} dependencyList={props.dependencyList} />
          ) : pos.text ? (
            <div className="wx-KG0Lwsqo wx-gantt-tooltip-text">{pos.text}</div>
          ) : null}
        </div>
      ) : null}

      {children}
    </div>
  );
};

export default Tooltip;
